export const MAX_ITEMS = 99;
export const MAX_BAGS = 99;
export const CURRENCY = 'CHF';



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/cart.js